import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../../hooks/hooks';
import { selectPickupPointsQueryItems } from '../../../../../../../redux/pickup-points/selector';
import PageLoader from '../../../../../../../components/PageLoader';
import PickupPointComponent from '../components/pickup-point.component';
import { selectStoresListItems } from '../../../../../../../redux/stores/selector';
import { pickupPoints } from '../../../../../../../redux/pickup-points/action';

const ManagementPickupPoint = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const pickupPointsQuery = useSelector(selectPickupPointsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const storeItems = useSelector(selectStoresListItems)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    selectedPickupPoint,
    setSelectedPickupPoint
  ] = useState({
    IsUsePrimaryAddressAsBillingAddress: false,
    IsUsePrimaryAddressAsShippingAddress: false,
    PickupPointInfo: {},
    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })
  const fetchPickupPointsQueryById= ()=>{
    dispatch(pickupPoints.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points/query`,entity:'pickupPoints',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedPickupPoint({ ...selectedPickupPoint, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedPickupPoint({ ...selectedPickupPoint, [field]: event })
  }
  
  useEffect(
    () => {
   
            if (parmas?.id > 0) {
                fetchPickupPointsQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedPickupPoint(pickupPointsQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: pickupPointsQuery?.result?.items?.PrimaryAddress,
            BillingAddress: pickupPointsQuery?.result?.items?.BillingAddress,
            ShippingAddress: pickupPointsQuery?.result?.items?.ShippingAddress})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const pickupPointData= {
   
        PickupPointInfo:selectedPickupPoint?.PickupPointInfo,
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedPickupPoint?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedPickupPoint?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
     
      if (parmas?.id > 0) {
     dispatch(pickupPoints.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points`,entity:'pickupPoints',jsonData:{
          
    Records: [
        pickupPointData
    ]
 
}})) .then(()=>{
    back()
  })
      }
      else{
        dispatch(pickupPoints.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points`,entity:'pickupPoints',jsonData:{
            
        Records: [
            pickupPointData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/stores/pickup-points')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <PickupPointComponent 
          stores={storeItems?.result?.items}
          handleInnerbasicFormChange ={handleInnerbasicFormChange}
          back={back}
          onInnerFormChange ={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          selectedAddress={selectedAddress}
          selectedPickupPoint={selectedPickupPoint}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementPickupPoint;